module.exports = __webpack_public_path__ + "img/keyboard_arrow_down-24px.31f8306a.svg";